import { SubscriptionFeature } from "@/types/auth";

export interface LockedFeatureCopy {
  title: string;
  lead: string;
  points: string[];
}

// Textos da tela "Funcionalidade bloqueada" (canvas: FuncionalidadeBloqueada).
export type LockedFeatureKey =
  | "overview"
  | "linkGenerator"
  | "site"
  | "googleAds"
  | "metaAds"
  | "tags"
  | "funnel"
  | "integrations";

export const LOCKED_FEATURES: Record<LockedFeatureKey, LockedFeatureCopy> = {
  overview: {
    title: "Visão geral",
    lead: "Centralize todas as informações do seu marketing em dashboards intuitivos, com dados completos e fáceis de interpretar.",
    points: [
      "Monitore visitantes em tempo real, acessos totais, leads, pedidos, faturamento, ticket médio, investimento em Google Ads e Meta Ads, ROAS e CPA.",
      "Veja top tags de acessos e pedidos e impressões e alcance por canal.",
      "Acompanhe a evolução de acessos, faturamento, pedidos, ticket médio, ROAS e CPA.",
    ],
  },
  linkGenerator: {
    title: "Gerador de link",
    lead: "Crie campanhas de anúncios com links organizados de forma simples e centralizada.",
    points: [
      "Alcance os principais canais: sites, redes sociais, WhatsApp, Google Ads e Meta Ads.",
      "Adicione tags e o pixel do Facebook para capturar as informações dos seus anúncios e do seu site.",
      "Gerencie todos os links criados em uma listagem completa.",
    ],
  },
  site: {
    title: "Seu site",
    lead: "Acesse dashboards exclusivos com dados extraídos diretamente do seu site.",
    points: [
      "Acompanhe visitantes em tempo real, acessos totais, leads, pedidos, faturamento e ticket médio.",
      "Veja a evolução de acessos, visitas por dia da semana e horário, páginas mais visitadas, referenciadores, canais de origem e páginas de saída.",
      "Descubra de onde vêm os visitantes com o mapa geográfico.",
    ],
  },
  googleAds: {
    title: "Google Ads",
    lead: "Visualize todas as suas campanhas do Google Ads centralizadas em um único painel.",
    points: [
      "Entenda cada campanha com acessos, leads, pedidos, faturamento, ticket médio, investimento total, ROAS e CPA.",
      "Analise impressões, top tags, top campanhas e top anúncios.",
      "Veja dispositivos, gênero e faixa etária para otimizar seus resultados.",
    ],
  },
  metaAds: {
    title: "Meta Ads",
    lead: "Visualize todas as suas campanhas do Meta Ads centralizadas em um único painel.",
    points: [
      "Entenda cada campanha com acessos, leads, pedidos, faturamento, ticket médio, investimento total, ROAS e CPA.",
      "Analise impressões, anúncios veiculados, tags com maior acesso e conversão, top campanhas e top anúncios.",
      "Veja dispositivos, gênero e faixa etária.",
    ],
  },
  tags: {
    title: "Tags",
    lead: "Todas as suas tags de rastreio reunidas em um único lugar.",
    points: [
      "Acompanhe o desempenho de todas as tags criadas no gerador de links.",
      "Monitore por tag: visitantes em tempo real, acessos, leads, pedidos, faturamento, ticket médio, investimento, ROAS e CPA.",
      "Entenda como cada tag performa em cada canal: Google, site, Instagram e outros.",
    ],
  },
  funnel: {
    title: "Funil de vendas",
    lead: "Visualize em qual etapa do funil de vendas cada lead se encontra, do primeiro acesso até a conversão.",
    points: [
      "Monitore visitantes, leads, pedidos, faturamento, ticket médio, investimento total, ROAS e CPA.",
      "Acompanhe a distribuição dos leads por etapa do funil.",
      "Identifique onde estão as maiores oportunidades de melhoria.",
    ],
  },
  integrations: {
    title: "Integrações",
    lead: "Configure scripts de rastreamento e conversão.",
    points: [
      "Instale o código de monitoramento no seu site.",
      "Configure o script de conversão para e-commerce ou leads.",
      "Conecte as contas do Google Ads e do Meta Ads.",
    ],
  },
};

export const FEATURE_KICKER: Record<SubscriptionFeature, string> = {
  "site-analytics": "Recurso de Analytics",
  showcase: "Recurso do Yuha! Social",
};
